/* Claude fixes 89 (track89, Mads 15 Oct 2026): first-party session data on the visitor's own cart, nothing else.
   Cart attributes (Shopify merges keys; this file sends only its own, never '' and never other apps' keys):
   - "Indgang side"    first page of the session: produkt | kollektion | blog | forside | beregnerside | side | kurv | andet
   - "Indgang kilde"   google-ads | google | facebook | instagram | email | anden-side: <host> | direkte
                       ("ukendt" for both when recording starts on a later page, e.g. consent given on page 2)
   - "Blog læst antal" distinct blog articles viewed this session; "Sider set" = page views this session
   Stored in sessionStorage 'fbVisit' only (no cookies, no localStorage), sent only to /cart/update.js, and only when the
   cart has items: on page load when a value changed ("Sider set" alone: when 5+ behind, or on the cart page) and right
   after an add. NEED_CONSENT (Mads 16:48Z): recorded and sent only with statistics consent (Shopify customerPrivacy
   analyticsProcessingAllowed()); without it nothing is stored, and a withdrawn consent removes 'fbVisit'.
   Also (calculator, functional, no consent gate): on pages where assets/fb-feeding-calc.js is not running, an add after a
   calculator result this session sets "Foderberegner k\u00f8bt via" = udenfor (sessionStorage 'fbfc:via', shared with the
   calculator, which sends it itself where it runs). Config from layout/theme.liquid: window.fbVisitCtx.
   Claude fixes 90 (recs90, CRO-8): two more functional keys, no consent gate (a click on our own alternative / an explicit
   signup, like the calculator keys), never sent as '':
   - "Alternativ fra"  where an alternative was taken from: <sold-out product handle> (page opened with ?ref=alt from a
                       product page of this shop; "ukendt" if the referrer is missing), "kollektion <handle>" / "guide <handle>"
                       (a card, link or K\u00f8b in the "midlertidigt udsolgt" box, written by snippets/fb-brand-soldout.liquid).
                       sessionStorage 'fbvAlt', the latest one wins.
   - "Besked tilmeldt" back-in-stock signups this session: product handle or "kollektion <handle>", newest last, max 3,
                       ", "-separated (written by fb-buybox-trust / fb-brand-soldout via window.fbVisitBis). sessionStorage 'fbvBis'.
   Claude fixes 90 (CRO-10): consent given on the landing page itself is now caught even when the banner's
   setTrackingConsent(true) fires no visitorConsentCollected (the theme banner uses the legacy call): the legacy
   'trackingConsentAccepted' event, the event detail, and a short re-check after a click in the cookie banner plus a slow
   re-check for 90 s. The page is then recorded as the landing page with its own referrer/URL source. */
(function () {
  'use strict';
  var NEED_CONSENT = true; // false = the four session keys without a consent gate (one-line switch)
  if (window.fbVisitDone) return; window.fbVisitDone = true;
  var C = window.fbVisitCtx || {}, KEY = 'fbVisit', VIA = 'Foderberegner k\u00f8bt via';
  var ROOT = C.root || '/', items = +C.n || 0, known = C.at || {};
  var rawFetch = window.fetch ? window.fetch.bind(window) : null;
  var OWN = ['Indgang side', 'Indgang kilde', 'Blog l\u00e6st antal', 'Sider set'];
  var FN = [['Alternativ fra', 'fbvAlt'], ['Besked tilmeldt', 'fbvBis']]; // functional, no consent gate

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} return null; }
  var granted = null; // analyticsAllowed from a consent event on this page (true/false), null = none seen
  function consentOk() {
    if (!NEED_CONSENT) return true;
    if (granted === false) return false;
    try { var p = window.Shopify && Shopify.customerPrivacy; if (p && typeof p.analyticsProcessingAllowed === 'function' && p.analyticsProcessingAllowed() === true) return true; } catch (e) {}
    return granted === true;
  }
  function host(u) { try { return new URL(u).hostname.toLowerCase().replace(/^www\./, ''); } catch (e) { return ''; } }
  var me = location.hostname.toLowerCase().replace(/^www\./, '');
  function side() {
    var t = C.pt || '';
    if (t === 'product') return 'produkt';
    if (t === 'collection' || t === 'list-collections') return 'kollektion';
    if (t === 'article' || t === 'blog') return 'blog';
    if (t === 'index') return 'forside';
    if (t === 'page') return C.ph === 'foderberegner' ? 'beregnerside' : 'side';
    if (t === 'cart') return 'kurv';
    return 'andet';
  }
  function source() {
    var q; try { q = new URLSearchParams(location.search); } catch (e) { q = { get: function () { return null; } }; }
    var med = (q.get('utm_medium') || '').toLowerCase(), src = (q.get('utm_source') || '').toLowerCase();
    if (q.get('gclid') || q.get('gbraid') || q.get('wbraid')) return 'google-ads';
    if (/google/.test(src) && /^(cpc|ppc|paid|paidsearch|paid_search|paid-search|sem|pmax)$/.test(med)) return 'google-ads';
    if (/e-?mail|newsletter|nyhedsbrev/.test(med)) return 'email';
    if (/instagram|^ig$/.test(src)) return 'instagram';
    if (/facebook|^fb$|^meta$/.test(src) || q.get('fbclid')) return 'facebook';
    var r = host(document.referrer);
    if (r && r !== me) {
      if (/(^|\.)google\.[a-z.]+$/.test(r)) return 'google';
      if (/(^|\.)(instagram\.com)$/.test(r)) return 'instagram';
      if (/(^|\.)(facebook\.com|fb\.com|fb\.me|messenger\.com)$/.test(r)) return 'facebook';
      return 'anden-side: ' + r;
    }
    return 'direkte';
  }
  function load() { try { return JSON.parse(ss(KEY) || 'null'); } catch (e) { return null; } }
  var recorded = false;
  function record() { // once per page view, only with consent
    if (recorded || !consentOk()) return null;
    var s = load();
    if (!s || typeof s !== 'object') {
      var later = host(document.referrer) === me; // recording starts on a later page of the visit
      s = { s: later ? 'ukendt' : side(), k: later ? 'ukendt' : source(), b: [], n: 0 };
    }
    if (!Array.isArray(s.b)) s.b = [];
    s.n = (+s.n || 0) + 1;
    if (C.a && s.b.indexOf(String(C.a)) < 0 && s.b.length < 200) s.b.push(String(C.a));
    ss(KEY, JSON.stringify(s)); recorded = true;
    return s;
  }
  function wipe() { ss(KEY, null); recorded = false; }
  function ownAttrs() {
    var s = consentOk() && load(); if (!s) return null;
    var a = {}; a[OWN[0]] = s.s || ''; a[OWN[1]] = s.k || ''; a[OWN[2]] = String((s.b || []).length); a[OWN[3]] = String(+s.n || 0);
    return a;
  }
  // calculator flag: only where the calculator's own cart hook is not running
  function calcVia() { return !window.fbfcHooked && ss('fbfc:shown') ? ss('fbfc:via') || '' : ''; }

  var busy = false, again = false, t = null;
  function sync(afterAdd) {
    if (!rawFetch || (!items && !afterAdd)) return;
    if (busy) { again = afterAdd || again === 'add' ? 'add' : 'yes'; return; }
    var out = {}, any = false, a = ownAttrs();
    if (a) OWN.forEach(function (k) {
      var v = a[k]; if (!v || known[k] === v) return;
      if (k === 'Sider set' && !afterAdd && C.pt !== 'cart' && known[k] && (+v - (+known[k] || 0)) < 5 && (+v - (+known[k] || 0)) >= 0) return;
      out[k] = v; any = true;
    });
    if (any && a) OWN.forEach(function (k) { if (a[k]) out[k] = a[k]; }); // send the set together
    var via = calcVia(); if (via && known[VIA] !== via) { out[VIA] = via; any = true; }
    FN.forEach(function (f) { var v = ss(f[1]) || ''; if (v && known[f[0]] !== v) { out[f[0]] = v; any = true; } });
    if (!any) return;
    busy = true;
    rawFetch(ROOT + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: out }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.attributes) { known = {}; OWN.concat([VIA], FN.map(function (f) { return f[0]; })).forEach(function (k) { if (j.attributes[k] != null) known[k] = String(j.attributes[k]); }); }
        if (j && 'item_count' in j) items = +j.item_count || 0;
      }, function () {})
      .then(function () { busy = false; if (again) { var x = again === 'add'; again = false; sync(x); } });
  }
  function onAdd() {
    items = Math.max(items, 1);
    if (!window.fbfcHooked && ss('fbfc:shown') && !ss('fbfc:via')) ss('fbfc:via', 'udenfor');
    clearTimeout(t); t = setTimeout(function () { sync(true); }, 300);
  }
  function isAdd(u) { try { return /\/cart\/add(\.js|\.json)?$/.test(new URL(String(u && u.url || u), location.href).pathname); } catch (e) { return false; } }
  try {
    if (rawFetch && !window.fetch.fbVisitWrap) {
      var wf = function (u, o) {
        var p = rawFetch(u, o);
        try { if (isAdd(u)) p.then(function (r) { if (r && r.ok) onAdd(); }, function () {}); } catch (e) {}
        return p;
      };
      wf.fbVisitWrap = true; window.fetch = wf;
    }
    var XP = window.XMLHttpRequest && XMLHttpRequest.prototype;
    if (XP && !XP.fbVisitWrap) {
      XP.fbVisitWrap = true; var xo = XP.open, xs = XP.send;
      XP.open = function (m, u) { try { this.fbVisitAdd = isAdd(u); } catch (e) {} return xo.apply(this, arguments); };
      XP.send = function () { try { var x = this; if (x.fbVisitAdd) x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) onAdd(); }); } catch (e) {} return xs.apply(this, arguments); };
    }
    // a plain form post to /cart/add leaves the page; the cart page then sends
    document.addEventListener('submit', function (e) {
      try { var f = e.target; if (!e.defaultPrevented && f && /\/cart\/add/.test(f.getAttribute('action') || '') && !window.fbfcHooked && ss('fbfc:shown') && !ss('fbfc:via')) ss('fbfc:via', 'udenfor'); } catch (x) {}
    });
  } catch (e) {}

  // Claude fixes 90 (CRO-8): "Alternativ fra" from the "Se <alternativ>" link (?ref=alt, fb-buybox-trust) and the signup helper
  try {
    if (new URLSearchParams(location.search).get('ref') === 'alt') {
      var rp = ''; try { var ru = new URL(document.referrer); if (ru.hostname.toLowerCase().replace(/^www\./, '') === me) { var m = ru.pathname.match(/\/products\/([^\/?#]+)/); if (m) rp = decodeURIComponent(m[1]); } } catch (e) {}
      ss('fbvAlt', (rp || 'ukendt').slice(0, 120));
    }
  } catch (e) {}
  window.fbVisitBis = function (what) { // called after a successful back-in-stock signup
    try {
      what = String(what || '').trim().slice(0, 120); if (!what) return;
      var l = (ss('fbvBis') || '').split(', ').filter(function (x) { return x && x !== what; }); l.push(what);
      ss('fbvBis', l.slice(-3).join(', ')); sync(false);
    } catch (e) {}
  };
  window.fbVisitAlt = function (what) { try { what = String(what || '').trim().slice(0, 120); if (what) ss('fbvAlt', what); } catch (e) {} };

  function start() { if (consentOk()) record(); else if (NEED_CONSENT) { wipe(); watch(); } sync(false); }
  function onConsent(e) {
    var d = e && e.detail; if (d && typeof d.analyticsAllowed === 'boolean') granted = d.analyticsAllowed;
    if (consentOk()) { if (!recorded) { record(); sync(false); } } else if (NEED_CONSENT) { wipe(); if (!d) burst(); }
  }
  document.addEventListener('visitorConsentCollected', onConsent);
  document.addEventListener('trackingConsentAccepted', onConsent); // legacy event name (theme banner, common.js)
  // CRO-10: consent can arrive on this page without an event we hear; re-check briefly after a banner click, and slowly for 90 s
  var wt = null, bt = null;
  function check() { if (recorded || !NEED_CONSENT) { clearInterval(wt); clearInterval(bt); return; } if (consentOk()) { clearInterval(wt); clearInterval(bt); record(); sync(false); } }
  function burst() { clearInterval(bt); var n = 0; bt = setInterval(function () { check(); if (++n >= 32) clearInterval(bt); }, 250); }
  function watch() {
    if (wt) return; var n = 0; wt = setInterval(function () { check(); if (++n >= 60) clearInterval(wt); }, 1500);
    document.addEventListener('click', function (e) { try { if (!recorded && e.target && e.target.closest && e.target.closest('.cookies-banner,[id*="cookie" i],[class*="cookie" i],[id*="consent" i],[class*="consent" i],#shopify-pc__banner')) burst(); } catch (x) {} }, true);
  }
  if (NEED_CONSENT && !(window.Shopify && Shopify.customerPrivacy) && window.Shopify && typeof Shopify.loadFeatures === 'function') {
    try { Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { start(); }); } catch (e) { start(); }
  } else start();
})();
